"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var scoresheetByAdjudicatorUrl = exports.scoresheetByAdjudicatorUrl = function scoresheetByAdjudicatorUrl(fid, eid, aid) {
  return IFEIS_API_URI + "/api/feiseanna/" + fid + "/events/" + eid + "/adjudicator/" + aid + "/scoresheet/complete";
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/scoresheet/paths.js
// module id = 676
// module chunks = 0